import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle, faInfo, faTimes } from '@fortawesome/free-solid-svg-icons';

export type AlertType = 'success' | 'error' | 'info' | 'warning';

interface AlertProps {
  type: AlertType;
  message: string;
  onClose?: () => void;
  isVisible: boolean;
}

export const Alert: React.FC<AlertProps> = ({ type, message, onClose, isVisible }) => {
  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FontAwesomeIcon icon={faCheckCircle} />;
      case 'error':
        return <FontAwesomeIcon icon={faExclamationCircle}  />;
      case 'warning':
        return <FontAwesomeIcon icon={faExclamationCircle}  />;
      case 'info':
        return <FontAwesomeIcon icon={faInfo}  />;
      default:
        return <FontAwesomeIcon icon={faInfo}  />;
    }
  };

  return (
    <div className={`alert alert-${type}`}>
      <div className="alert-content">
        <div className="alert-icon">
          {getIcon()}
        </div>
        <div className="alert-message">
          {message}
        </div>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="alert-close"
            aria-label="Fechar alerta"
          >
            <FontAwesomeIcon icon={faTimes}  />
          </button>
        )}
      </div>
    </div>
  );
};
